import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=7ab9f446&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=ts"
export * from "./MentionsLegales.vue?vue&type=script&lang=ts"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&id=7ab9f446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9f446",
  null
  
)

export default component.exports